module.exports = __webpack_public_path__ + "static/media/slack_analyze_result3.249b04b3.png";